import React from 'react'

import { ZariContext } from '_zari/context'

import { TreeView, Portlet, Row, Col, Button } from '_zari/core'

import * as EstructuraBalanaceService from 'services/estructuraBalance.service'

import * as Modals from './modals'

const portletBreadcrumbs = [{ name: 'Lista' }]

const EstructuraBalanceLista = () => {
  const [estructuraBalanceLista, setEstructuraBalanceLista] = React.useState([])
  const [mostrarNuevoModal, setMostrarNuevoModal] = React.useState(false)
  const [mostrarEditarModal, setMostrarEditarModal] = React.useState(false)

  const __zariContext = React.useContext(ZariContext)

  const selectedNodeIdRef = React.useRef('')
  const editarDataRef = React.useRef(null)

  const refreshTreeView = React.useCallback(() => {
    EstructuraBalanaceService.getAsTreeView().then(({ data }) => {
      setEstructuraBalanceLista(data)
    })
  }, [setEstructuraBalanceLista])

  const clickEditar = React.useCallback(() => {
    if (selectedNodeIdRef.current.length > 4) {
      EstructuraBalanaceService.getEstructuraBalance(selectedNodeIdRef.current)
        .then(({ data }) => {
          editarDataRef.current = data
          setMostrarEditarModal(true)
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    } else {
      __zariContext.snack('error', 'No se puede editar un registro en este nivel.')
    }
  }, [__zariContext])

  const clickEliminar = React.useCallback(() => {
    if (selectedNodeIdRef.current.length > 4) {
      EstructuraBalanaceService.eliminarEstructuraBalance(selectedNodeIdRef.current)
        .then(() => {
          __zariContext.snack('success', 'El registro se ha eliminado.')
          refreshTreeView()
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    } else {
      __zariContext.snack('error', 'No se puede eliminar un registro en este nivel.')
    }
  }, [__zariContext, refreshTreeView])

  React.useEffect(() => {
    refreshTreeView()
  }, [refreshTreeView])

  const onSelectEstructura = React.useCallback(newNode => {
    selectedNodeIdRef.current = newNode
  }, [])

  const clickNuevaEstructuraBalance = React.useCallback(() => {
    if (selectedNodeIdRef.current.length > 1 && selectedNodeIdRef.current.length < 4) {
      setMostrarNuevoModal(true)
    } else {
      __zariContext.snack('error', 'No se puede crear un registro en este nivel.')
    }
  }, [setMostrarNuevoModal, selectedNodeIdRef, __zariContext])

  return (
    <>
      <Portlet>
        <Portlet.Header title='Estructura Balance' breadcrumbs={portletBreadcrumbs} />
        <Portlet.Body>
          <Row className='mb-2'>
            <Col md={12} className='text-right'>
              <Button outline tiny onClick={clickNuevaEstructuraBalance}>
                Agregar
              </Button>
              <Button outline tiny onClick={clickEditar}>
                Editar
              </Button>
              <Button color='danger' outline tiny onClick={clickEliminar}>
                Eliminar
              </Button>
            </Col>
          </Row>
          <div className='treeview_wrapper'>
            <TreeView items={estructuraBalanceLista} onSelect={onSelectEstructura} />
          </div>
        </Portlet.Body>
      </Portlet>
      {mostrarNuevoModal && (
        <Modals.NuevoModal
          idNodoSeleccionado={selectedNodeIdRef.current}
          show={mostrarNuevoModal}
          handleClose={() => setMostrarNuevoModal(false)}
          refreshTreeView={refreshTreeView}
        />
      )}
      {mostrarEditarModal && (
        <Modals.NuevoModal
          idNodoSeleccionado={selectedNodeIdRef.current}
          show={mostrarEditarModal}
          handleClose={() => setMostrarEditarModal(false)}
          refreshTreeView={refreshTreeView}
          editarData={editarDataRef.current}
        />
      )}
    </>
  )
}

export default EstructuraBalanceLista
